import { RootState } from '../../RootState';

const selectTasksPending = (state: RootState): boolean => {
  const isNavigating = state.router.isNavigating;
  return state.tasks.pendingTaskCount > 0 || isNavigating;
};

export default selectTasksPending;
